import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faBriefcase } from "@fortawesome/pro-solid-svg-icons/faBriefcase";
import { faHome } from "@fortawesome/pro-solid-svg-icons/faHome";
import { faStar } from "@fortawesome/pro-solid-svg-icons/faStar";

import SavedAddressType from "@mapmycustomers/shared/enum/SavedAddressType";

const savedAddressIcons: Record<SavedAddressType, IconDefinition> = {
  [SavedAddressType.CUSTOM]: faStar,
  [SavedAddressType.HOME]: faHome,
  [SavedAddressType.WORK]: faBriefcase,
};

export default savedAddressIcons;
